/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import { money } from '~hooks/useHelpers';

const useProgress = (utilizado, disponivel, total, setTotal, buff, input, limiteMaximo, limiteAdicional) => {
  const [updatedTotal, setUpdatedTotal] = useState(0);
  const [updatedProgressValue, setUpdatedProgressValue] = useState(0);
  const [updatedTotalFormat, setUpdatedTotalFormat] = useState("");
  const [isUpdatedMinimal, setIsUpdatedMinimal] = useState(false);

  const [initialTotal, setInitialTotal] = useState(total);
  const [initialTotalFormat, setInitialTotalFormat] = useState("");

  const [utilizadoProgressValue, setUtilizadoProgressValue] = useState(parseInt(utilizado * 100 / total));
  const [totalFormat, setTotalFormat] = useState("");

  const [disponivelFormat, setDisponivelFormat] = useState(0);
  const [utilizadoFormat, setUtilizadoFormat] = useState(0);

  const handleClickLess = (e) => {
    e.preventDefault();

    if (total > utilizado) {
      let value = total - buff;

      if (value < utilizado) {
        value = utilizado;
        setIsUpdatedMinimal(true);
      }

      setTotal(value);
    }
  };

  const handleClickMore = (e) => {
    e.preventDefault();
    if (utilizado > total) {
      const difference = utilizado - total;
      let value = total + difference + buff ;
      setTotal(value);
    } else {
      let value = total + buff;
      if (isUpdatedMinimal) {
        value = Math.ceil(utilizado / buff) * buff;
        setIsUpdatedMinimal(false);
      }

      setTotal(value);
    }
  };


  useEffect(() => {
    let totalReal = total;

    if (total < utilizado) {
      totalReal = utilizado;
      setIsUpdatedMinimal(true);
    } else {
      setIsUpdatedMinimal(false);
    }

    setTotalFormat(money(totalReal));
    setInitialTotalFormat(money(initialTotal));

    setUpdatedTotal(totalReal - initialTotal);
    setUpdatedTotalFormat(money(Math.abs(updatedTotal)));
    setUtilizadoProgressValue(parseInt(utilizado * 100 / totalReal));
    setUpdatedProgressValue(parseInt(updatedTotal * 100 / totalReal));
  }, [total, updatedTotal, utilizado]);

  useEffect(() => {
    setUtilizadoFormat(money(utilizado));
  }, [utilizado]);

  useEffect(() => {
    setDisponivelFormat(money(disponivel));
  }, [disponivel]);

  useEffect(() => {
    setTotalFormat(money(total));
    setInitialTotalFormat(money(initialTotal));
    setUpdatedTotalFormat(money(Math.abs(updatedTotal)));

    setDisponivelFormat(money(disponivel));
    setUtilizadoFormat(money(utilizado));
  }, []);

  return {
    utilizadoProgressValue,
    total,
    utilizado,
    totalFormat,
    updatedTotal,
    updatedTotalFormat,
    updatedProgressValue,
    initialTotalFormat,
    disponivelFormat,
    utilizadoFormat,
    handleClickMore,
    handleClickLess,
    buff,
    isUpdatedMinimal,
    setIsUpdatedMinimal
  };
};

export default useProgress;
